import { render } from "./payment-hdp-direct.vue?vue&type=template&id=5fcdbe4a"
import script from "./payment-hdp-direct.vue?vue&type=script&lang=js"
export * from "./payment-hdp-direct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__